import React, { FunctionComponent } from 'react';
import { INodeBodyProps } from './types';

export const NodeBody: FunctionComponent<INodeBodyProps> = ({ description }) => {
  const descriptionList = description.split('\n');
  return (
    <div>
      <ul>
        {descriptionList.map((desc, index) => (
          <li key={index} className="chart-desc-items">
            {desc}
          </li>
        ))}
      </ul>
    </div>
  );
};
